<template>
  <Concept_index></Concept_index>
  <Concept_page></Concept_page>
  <a-row style="height: 5vh"/>
  <Footer></Footer>
</template>

<script>
import Concept_index from '../../components/CN/concept/Concept_index';
import Concept_page from "../../components/CN/concept/Concept_page";
import Footer from "../../components/CN/Footer";
import Header from '../../components/CN/Header'

export default {
  name: 'Concept',
  components: {Concept_page, Concept_index, Footer, Header},
}

</script>